export const ON_MATCH_STATUS_CHANGED = `
  subscription OnMatchStatusChanged($matchId: ID!) {
    onMatchStatusChanged(matchId: $matchId) {
      matchId
      campaignId
      influencerId
      userId
      status
      proposedRate
      message
      matchScore
      appliedAt
      respondedAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const ON_CAMPAIGN_CREATED = `
  subscription OnCampaignCreated($category: String) {
    onCampaignCreated(category: $category) {
      campaignId
      userId
      title
      description
      category
      budget
      timeline {
        startDate
        endDate
      }
      requirements {
        minFollowers
        minEngagementRate
        preferredLocations
        preferredLanguages
        contentType
        deliverables
      }
      status
      applicationsCount
      matchesCount
      createdAt
      updatedAt
    }
  }
`;

export const ON_MATCH_CREATED = `
  subscription OnMatchCreated($campaignId: ID!) {
    onMatchCreated(campaignId: $campaignId) {
      matchId
      campaignId
      influencerId
      userId
      status
      proposedRate
      message
      matchScore
      appliedAt
      respondedAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const ON_USER_UPDATED = `
  subscription OnUserUpdated($userId: ID!) {
    onUserUpdated(userId: $userId) {
      userId
      email
      name
      userType
      profileImage
      bio
      website
      createdAt
      updatedAt
    }
  }
`;

// Real-time messaging subscriptions
export const ON_MESSAGE_RECEIVED = `
  subscription OnMessageReceived($conversationId: ID!) {
    onMessageReceived(conversationId: $conversationId) {
      messageId
      conversationId
      senderId
      receiverId
      messageType
      content
      attachments {
        fileId
        fileName
        fileUrl
        fileType
      }
      readStatus {
        isRead
        readAt
      }
      campaignId
      matchId
      createdAt
      updatedAt
    }
  }
`;

// Typing indicator subscriptions
export const ON_TYPING_STATUS_CHANGED = `
  subscription OnTypingStatusChanged($conversationId: ID!) {
    onTypingStatusChanged(conversationId: $conversationId) {
      userId
      conversationId
      isTyping
      timestamp
    }
  }
`;

// User presence subscriptions
export const ON_PRESENCE_CHANGED = `
  subscription OnPresenceChanged($conversationId: ID!) {
    onPresenceChanged(conversationId: $conversationId) {
      userId
      conversationId
      isOnline
      lastSeen
      timestamp
    }
  }
`;

// Conversation updates (last message, unread count)
export const ON_CONVERSATION_UPDATED = `
  subscription OnConversationUpdated($userId: ID!) {
    onConversationUpdated(userId: $userId) {
      conversationId
      participants
      lastMessage
      lastMessageContent
      campaignId
      matchId
      hostId
      influencerId
      lastMessageId
      lastMessageAt
      unreadCount {
        userId
        count
      }
      unreadCountValue
      createdAt
      updatedAt
    }
  }
`;
